// Clé publique RSA du serveur — utilisée pour chiffrer les corps des requêtes sensibles.
// Régénérer via : npm run generate-keys côté API, puis copier le contenu de public.pem ici.
export const RSA_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAxSn4dOf9k19HZNB9LqrG
qShEEZuhDrPPZm5/LkC0xGnI2xv7DumwPmAqx5VOQxWKk9FlMW9+ntHy88E2/CAX
rOntNyVaSzP/vFSNkQKQ/yBAPCEnbi9ueH9cb2QomH32yeRAhbikdD9VEGGr0SpW
EO9nSnbIA+424S3CIzAZEakP/QuFA+2nFWcXUEIy9+QY8UYV6nAZiCRbJn/nXz/A
34hV37xabB1BPYmbDiAnkfiYV8+foto7g+tous/tamlf2YX584wBPz7OQfgrYEaG
Vw36BqSJuB3wcJVdCglKlaM74NIqozh4heks0h09cSQcHx+JwF9r8cBXKYJTisxS
ZQIDAQAB
-----END PUBLIC KEY-----`;
